module.exports = __webpack_public_path__ + "img/20.86998287.png";